interface SectionHeadingProps {
  eyebrow: string
  title: string
  body?: string
  light?: boolean
}

export function SectionHeading({ eyebrow, title, body, light = false }: SectionHeadingProps) {
  return (
    <div className={`section-heading${light ? ' section-heading--light' : ''}`}>
      <p className="eyebrow">{eyebrow}</p>
      <h2>{title}</h2>
      {body ? <p>{body}</p> : null}
    </div>
  )
}
